import functions from "../../../../../world/spa/libs/vuexFunctions";

export default {
  namespaced: true,
  state: {
    objs: []
  },
  getters: {
    ...functions.createDefaultGetters(["idWorldFile"]),
    getByContact: (state) => contactId => {
      return state.objs.filter(file => file.contact && file.contact == contactId);
    },
  },
  mutations: {
    ...functions.createDefaultMutations(["idWorldFile"])
  },
  actions: {
    ...functions.createDefaultActionsWithStore(["idWorldFile"])
  }
};
